export default __webpack_public_path__ + "static/media/psicoqueretaro2026.d765c132.pdf";